class PaginationChange extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      nextTrigger: this.querySelector('[data-pagination-change-el="next-trigger"]'),
      prevTrigger: this.querySelector('[data-pagination-change-el="prev-trigger"]')
    }

    this.state = {
      root: window.theme.category ? window.theme.category.stateLayer.state : window.theme.searchResults.stateLayer.state
    }
  }

  connectedCallback() {
    this.subscribeToEvents();
    this.attachEventListeners();
  }

  subscribeToEvents() {
    if(window.theme.searchResults) {
      window.theme.searchResults.eventBus.subscribe('searchResults:state:products:updated', (products) => {

        if(products.length > 0) {
          this.render()
        } else {
          this.classList.add('hidden');
        }
      })
    }

    if(window.theme.category) {
      window.theme.category.eventBus.subscribe('category:api:products:fetched', (res) => {
        if(res.products.hits.length > 0) {
          this.render()
        } else {
          this.classList.add('hidden');
        }
      })

      window.theme.category.eventBus.subscribe('category:shopify:products:fetched', () => {
        this.classList.add('hidden');
      })
    }
  }

  attachEventListeners() {
    this.elements.nextTrigger.addEventListener('click', (event) => {
      const { toCursor } = event.target.dataset;

      if(window.theme.category) {

        window.theme.category.eventBus.publish('category:ui:pagination:changed', {
          current: toCursor,
          direction: 'next'
        });
      }

      if(window.theme.searchResults) {
        window.theme.searchResults.eventBus.publish('searchResults:ui:pagination:changed', {
          current: toCursor,
          direction: 'next'
        });
      }

    });

    this.elements.prevTrigger.addEventListener('click', (event) => {
      const { toCursor } = event.target.dataset;

      if(window.theme.category) {
        window.theme.category.eventBus.publish('category:ui:pagination:changed', {
          current: toCursor,
          direction: 'previous'
        });
      }

      if(window.theme.searchResults) {
        window.theme.searchResults.eventBus.publish('searchResults:ui:pagination:changed', {
          current: toCursor,
          direction: 'previous'
        });
      }
    });
  }

  render() {
    const { pagination } = this.state.root;

    const nextCursor = pagination.from + pagination.size;
    const prevCursor = Math.max(pagination.from - pagination.size, 0);

    this.elements.nextTrigger.setAttribute('data-to-cursor', nextCursor);
    this.elements.prevTrigger.setAttribute('data-to-cursor', prevCursor);

    if (pagination.currentPage === pagination.totalPages) {
      this.elements.nextTrigger.classList.add('hidden');
    } else {
      this.elements.nextTrigger.classList.remove('hidden');
    }

    if (pagination.currentPage === 1) {
      this.elements.prevTrigger.classList.add('hidden');
    } else {
      this.elements.prevTrigger.classList.remove('hidden');
    }
  }

}

customElements.define('pagination-change', PaginationChange);
